import React from 'react';

import { NotifyModal } from 'components';

const VoiceSetupModel = ({
  onCancel,
  onConfirm,
  hasCancel,
  userName,
  pageName,
}) => {
  return (
    <NotifyModal
      open
      title="Assign a license?"
      confirmText="Assign a license"
      cancelText="Cancel"
      onCancel={onCancel}
      onConfirm={onConfirm}
      hasCancel={hasCancel}
    >
      <div className="m-notify-modal">
        <div
          className="m-notify-modal__main"
          data-testid="PlatformAdminUI-Users-VoiceSetupModal-Body"
        >
          <b>{`${userName}`}</b> doesn&#39;t have a license for <b>Voice</b>{' '}
          yet.
        </div>
        <div>
          You can assign a license to their profile and then return to continue{' '}
          {pageName}.
        </div>
      </div>
    </NotifyModal>
  );
};

VoiceSetupModel.defaultProps = {
  hasCancel: true,
};

export default VoiceSetupModel;
